import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Form, Button, } from 'react-bootstrap';
import Select from 'react-select';
import { ChooseComponent, useFetch, useTranslation, usePermission } from '@np/np_webcomponentlib'

import { API_BUSINESS } from '../../shared/consts/api'

import { EntityType, DataEntityType, EntityFormPropsWithType, initEntity, columnsRate } from './BusinessTypes'
import CredsForm from './CredsForm';
import { useNavigate } from 'react-router-dom';
import { optionsTypeCurrencyEnum, TypeBusinessEnum, TypeCurrencyEnum } from '../../shared/MasterData/MasterDataTypes';


// import { ColumnWithCopyToClipboard, ColumnData } from '../../shared/entityOperations/EntityOperationsCustomFC'



interface WizardIncomeType {
    entityBusiness: EntityType;
    login?: string;
    idRFRateTemplate?: string;
}




export const BusinessFormWizardProvider = () => {

    const navigate = useNavigate()
    
    const { canView, canCreate, canUpdate, canRemove, debugMode } = usePermission('$component_name');

    const initEntityWizard: WizardIncomeType = {
        entityBusiness: {
            name: "",
            techChat: "",
            receiptChatId: "",
            receiptForwardEnabled: false,
            fullName: "",
            contactEmail: "",
            noteText: "",
            idrfGeo: "00000000-0000-0000-0000-000000000000",
            currencyBalance: TypeCurrencyEnum.NOTSET,
            currencyPayment: TypeCurrencyEnum.NOTSET,
            providerURLHost: "",
            typeBusiness:  TypeBusinessEnum.provider,
            maxForwardRandomization: 0,

            idSourceRate: null,
            monoBankPaymentMethod: null,

            percentageOfExchangeRateSource: 0,
            percentExchangeRatePayOut: 0,

            maxCountParallelRequest: 0,
            maxMillisecondRequest: 0,
            listWhiteIP: ""
        },
        login: "",
        idRFRateTemplate: ""
        
    }


    

    const [wizardIncome, setWizardIncome] = useState<WizardIncomeType>(initEntityWizard);

    const [wizardData, setWizardData] = useState<any>(null);

    const [entity, setEntity] = useState<EntityType | DataEntityType>(initEntity)


    const [, doFetchCreateWizard] = useFetch(
            `${API_BUSINESS}business/wizard/provider`)//{ error: errCU, isLoading: isLoadCU, response: respCU }

    
    


    const handleSave = () => {
        //сначала проверим заполненность


        setEntity((prev) => { return { ...prev, typeBusiness:  TypeBusinessEnum.merchant} })

        var method = "POST"
        
        setWizardIncome((prev) => { return { ...prev, entityBusiness: entity} })

        doFetchCreateWizard({
            method: method,
            "Content-Type": "application/json",
            data: wizardIncome
        }).then(responce => {
            console.log(responce)
            setWizardData(responce.data)
            console.log("responce.result.status", responce.result.status)
            console.log(responce.data)
        })


    }




    const confirmButtonTitle = "Загрузить";//useTranslation('confirmButtonTitle')
    const rejectButtonTitle = useTranslation('rejectButtonTitle')

    const createButtonTitle = useTranslation('createButton')
    const updateButtonTitle = useTranslation('updateButton')


    return (<Card>
        <Card.Header>
            <Card.Title as='h4'>Создание мерчанта (поля отмеченные * обязательны)</Card.Title>
        </Card.Header>
        <Card.Body className="">
            {/* <Form className="form-horizontal"> */}

            

            {/* <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('typeBusiness')}</Form.Label>
                <Col md={9}>
                    <Select options={optionsEnumTypeBusiness} placeholder='choose one' classNamePrefix='Select' value={optionsEnumTypeBusiness.find(option => option.value === entity.typeBusiness) ?? optionsEnumTypeBusiness[0]}
                        onChange={e => setEntity((prev) => { return { ...prev, typeBusiness: e!.value } })} />
                </Col>
            </Row> */}

            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('name')}*</Form.Label>
                <Col md={9}>
                    <Form.Control type="text" placeholder={useTranslation('name')} value={wizardIncome.entityBusiness.name} onChange={e => setWizardIncome((prev) => { return { 
                    ...prev, 
                    entityBusiness: { 
                        ...prev.entityBusiness, // Копируем остальные поля entityBusiness
                        name: e.target.value // Обновляем только fullName
                    } 
                }  })} />
                </Col>
            </Row>


            {/* <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('login')}*(мин. 5 символов)</Form.Label>
                <Col md={9}>
                    <Form.Control type="text" placeholder={useTranslation('login')} value={wizardIncome?.login} onChange={e => setWizardIncome((prev) => { return { ...prev, login: e.target.value } })} />
                </Col>
            </Row> */}


            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('templateRate')}*</Form.Label>
                <Col md={9}>
                        <ChooseComponent
                                        getDisplayDescription={(seletedData: any) => {
                                            return seletedData ? seletedData.title : 'Выберите тариф'
                                        }}
                                        apiUrl={`${API_BUSINESS}raterepo/list`}
                                        columns={columnsRate}
                                        selectData={(selectData: any) => {
                                            setWizardIncome((prev) => { return { ...prev, idRFRateTemplate: selectData.idUnique } })
                                        }}
                                        resetData={() => {
                                            
                                        }}
                                        initIDUnique={wizardIncome?.idRFRateTemplate !== null ? wizardIncome?.idRFRateTemplate : ""}
                                    >
                                        Выберите Тариф
                                    </ChooseComponent>
                                    </Col>
                                    </Row>



            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('fullName')}</Form.Label>
                <Col md={9}>
                    <Form.Control type="text" placeholder={useTranslation('fullName')} value={wizardIncome.entityBusiness.fullName} onChange={e => setWizardIncome((prev) => { return { ...prev, entityBusiness: { 
                        ...prev.entityBusiness, // Копируем остальные поля entityBusiness
                        fullName: e.target.value // Обновляем только fullName
                    } } })} />
                </Col>
            </Row>


            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('currencyPayment')}*</Form.Label>
                <Col md={9}>
                <Select options={optionsTypeCurrencyEnum} placeholder='choose one' classNamePrefix='Select' value={optionsTypeCurrencyEnum.find(option => option.value === wizardIncome.entityBusiness.currencyPayment) ?? optionsTypeCurrencyEnum[0]}
                        onChange={e => setWizardIncome((prev) => { 
                            if (e && e.value) {  // проверка на наличие значения
                              return { 
                                ...prev, 
                                entityBusiness: { 
                                    ...prev.entityBusiness, // Копируем остальные поля entityBusiness
                                    currencyPayment: e.value // Обновляем только fullName
                                }
                              }; 
                            }
                            return prev;  // если нет значения, не изменяем состояние
                          })}  />
                </Col>
            </Row>



            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('currencyBalance')}*</Form.Label>
                <Col md={9}>
                <Select options={optionsTypeCurrencyEnum} placeholder='choose one' classNamePrefix='Select' value={optionsTypeCurrencyEnum.find(option => option.value === wizardIncome.entityBusiness.currencyBalance) ?? optionsTypeCurrencyEnum[0]}
                        onChange={e => setWizardIncome((prev) => { 
                            if (e && e.value) {  // проверка на наличие значения
                              return { 
                                ...prev, 
                                entityBusiness: { 
                                    ...prev.entityBusiness, // Копируем остальные поля entityBusiness
                                    currencyBalance: e.value // Обновляем только fullName
                                }
                              }; 
                            }
                            return prev;  // если нет значения, не изменяем состояние
                          })}  />
                </Col>
            </Row>


            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('providerURLHost')}</Form.Label>
                <Col md={9}>
                    <Form.Control type="text" placeholder={useTranslation('providerURLHost')} value={wizardIncome.entityBusiness.providerURLHost} onChange={e => setWizardIncome((prev) => { return { ...prev, entityBusiness: { 
                        ...prev.entityBusiness, // Копируем остальные поля entityBusiness
                        providerURLHost: e.target.value // Обновляем только fullName
                    }} })} />
                </Col>
            </Row>


           

            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('contractText')}</Form.Label>
                <Col md={9}>
                    <Form.Control type="text" placeholder={useTranslation('contractText')} value={wizardIncome.entityBusiness.contractText} onChange={e => setWizardIncome((prev) => { return { ...prev, entityBusiness: { 
                        ...prev.entityBusiness, // Копируем остальные поля entityBusiness
                        contractText: e.target.value // Обновляем только fullName
                    } } })} />
                </Col>
            </Row>

            


            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('techChat')}</Form.Label>
                <Col md={9}>
                    <Form.Control type="text" placeholder={useTranslation('techChat')} value={wizardIncome.entityBusiness.techChat} onChange={e => setWizardIncome((prev) => { return { ...prev, entityBusiness: {
                        ...prev.entityBusiness, // Копируем остальные поля entityBusiness
                        techChat: e.target.value // Обновляем только fullName
                    } } })} />
                </Col>
            </Row>


            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('receiptChatId')}</Form.Label>
                <Col md={9}>
                    <Form.Control type="text" placeholder={useTranslation('receiptChatId')} value={wizardIncome.entityBusiness.receiptChatId ?? ''} onChange={e => setWizardIncome((prev) => { return { ...prev, entityBusiness: {
                        ...prev.entityBusiness,
                        receiptChatId: e.target.value
                    } } })} />
                </Col>
            </Row>

            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('receiptForwardEnabled')}</Form.Label>
                <Col md={9}>
                    <Form.Check type="switch" checked={wizardIncome.entityBusiness.receiptForwardEnabled ?? false} onChange={e => setWizardIncome((prev) => { return { ...prev, entityBusiness: {
                        ...prev.entityBusiness,
                        receiptForwardEnabled: e.target.checked
                    } } })} />
                </Col>
            </Row>


            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('contactEmail')}</Form.Label>
                <Col md={9}>
                    <Form.Control type="text" placeholder={useTranslation('contactEmail')} value={wizardIncome.entityBusiness.contactEmail} onChange={e => setWizardIncome((prev) => { return { ...prev, entityBusiness: { 
                        ...prev.entityBusiness, // Копируем остальные поля entityBusiness
                        contactEmail: e.target.value // Обновляем только fullName
                    } } })} />
                </Col>
            </Row>




            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('noteText')}</Form.Label>
                <Col md={9}>
                    <Form.Control type="text" placeholder={useTranslation('noteText')} value={wizardIncome.entityBusiness.noteText} onChange={e => setWizardIncome((prev) => { return { ...prev, entityBusiness: { 
                        ...prev.entityBusiness, // Копируем остальные поля entityBusiness
                        noteText: e.target.value // Обновляем только fullName
                    } } })} />
                </Col>
            </Row>





            <Row className="mb-0">
                {canCreate &&
                    <Button onClick={() => { handleSave(); console.log(entity) }}> {createButtonTitle} </Button>
                }
            </Row>


            {/* {wizardData &&
                <CredsForm
                NameBusiness={wizardData.business.name}
                login={wizardData.login}
                tempPassword={wizardData.tempPassword}
                YourJWTToken={wizardData.yourJSWTToken}
                YourJWTTokenForWebhook={wizardData.yourJSWTTokenForWebhook}
              />
              
            } */}

            {wizardData &&
                <Button onClick={() => { { navigate("/business/" + wizardData.business.idUnique) } }}> Перейти к бизнесу </Button>
            }



        </Card.Body>
    </Card>)
}
